import { Directive, HostListener, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

const parsePathFromRoute = (router: Router) => {
	try {
		const url: string = router.url;
		const splittedUrl = url.split("?");
		if (splittedUrl.length > 1) {
			const mongoIdRegex = /^[\/0-9a-fA-F]{25}$/;
			return splittedUrl[0].match(mongoIdRegex) ? "/:orderId" : splittedUrl[0];
		}
		return url;
	} catch (e) {
		return "";
	}
};

@Directive({
	selector: "[captureEvent]",
})
export class CaptureEventDirective {
	constructor(private router: Router, private route: ActivatedRoute) {}

	@Input() captureEvent = "";

	@HostListener("click", ["$event"]) onBtnClick() {
		let path = `${this.route.snapshot.parent?.routeConfig?.path || ""}/${this.route.snapshot.routeConfig?.path || ""}`;
		this.captureUserEvent(this.captureEvent, path);
	}

	captureUserEvent(captureEvent: string, path?: string) {
		// console.log('🎯 Capturing user event:', captureEvent, 'with path:', path);
		if (!captureEvent) {
			return;
		}

		try {
			if (!path || path === "") {
				path = parsePathFromRoute(this.router);
			}

			// Check window.pendo instead of global pendo variable
			// This handles async loading of Pendo script from CDN
			const pendoInstance = (window as any).pendo;
			if (pendoInstance && typeof pendoInstance.track === 'function') {
				// Track the main event
				pendoInstance.track(captureEvent, {
					page: path,
				});

				// Also track the page view for analytics
				pendoInstance.track("Page-" + path, {
					event: captureEvent,
				});

				// console.log('✅ Event tracked:', captureEvent);
			} else if (this.captureEvent !== 'app-init') {
				// Only warn for non-initialization events
				console.warn('⚠️ P not available:', captureEvent);
			}
		} catch (error) {
			console.warn('Analytics tracking failed:', error);
			// Don't throw - don't break app if analytics fails
		}
	}
}
